// Crawler Vision Version Information
//
// All five fields below are rewritten by `cv-deploy.sh` →
// `ver_update_files` on every "Prepare Cloudflare deployable build" run:
//   * VERSION       — semver + auto-incrementing build segment (e.g. 3.7.0.5)
//   * VERSION_NAME  — human-readable release codename
//   * RELEASE_DATE  — ISO date the build was prepared
//   * BUILD_NUMBER  — the 4th segment, also exposed as a string
//   * COMMIT_ID     — short git revision id at build time (`git rev-parse --short=7`).
//                     Stays "dev" for non-deploy builds (e.g. `npm start`).
//
// `getStampString()` is the canonical "is this asset up to date?" string and
// must appear identically in every Footer / sidebar / status panel so that an
// admin can compare what they see in the browser against the production
// X-CV-Build response header and the /version.json artifact.
export const VERSION = '3.7.0.52';
export const VERSION_NAME = 'Pulse — cross-origin CORS fix (header-based session id)';
export const RELEASE_DATE = '2026-05-11';
export const BUILD_NUMBER = '261';
export const COMMIT_ID = '11a2ed3';

export const getVersionString = () => `v${VERSION}`;
export const getFullVersionString = () => `Crawler Vision Platform v${VERSION}`;

/**
 * Canonical build stamp shown in every UI surface and emitted as the
 * X-CV-Build response header. Format: `v3.7.0.5 #abc1234-5`. The hash
 * stays "dev" until cv-deploy.sh stamps a real revision id.
 */
export const getStampString = () => `v${VERSION} #${COMMIT_ID || 'dev'}-${BUILD_NUMBER}`;
